import { LenderName } from '@nemuru-eng/js-api-client';

export const NIE_DATA_REQUIRED_LENDER_NAMES: LenderName[] = [LenderName.SANTANDER_CONSUMER];
